import { useTranslation } from "react-i18next"
import "./ImgFormats.css"

type ImgFormatsProps = {
  text?: string
}

const ImgFormats = ({ text }: ImgFormatsProps) => {
  const { t } = useTranslation()
  return (
    <p className="text-img-allowed">{text ?? t("General:label_120")}</p>
  )
}

export default ImgFormats